import React from "react";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchConfiguration: React.FC<Props> = ({ value, onChange }) => {
  const { fontClass, borderHighlight } = useUserTheme();
  return (
    <input
      id="Search-Category-name"
      placeholder="Search by Configuration Name"
      className={`w-full max-w-[350px] px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
      type="tel"
      value={value}
      onChange={onChange}
    />
  );
};

export default SearchConfiguration;
